/**
 * Decodes a URI value with error handling.
 *
 * This is needed because some values are not properly encoded and will throw an error.
 * For example: Percent-encoding requires two hexadecimal digits following the % character,
 * representing the ASCII code of the character to be encoded. However, %ea is followed by an i,
 * not two hexadecimal digits.
 *
 * @param value string
 * @returns
 */
export function decodeURI(value: string) {
  try {
    return decodeURIComponent(value)
  } catch {
    return decodeURIComponent(encodeURIComponent(value))
  }
}

/**
 * Checks if a given string is a valid URL.
 * @param url string
 * @returns boolean
 * @example
 * var text1 = "https://example.com/image.jpg";
 * var text2 = "https://www.google.com";
 * var text3 = "example invalid link";
 * console.log(isImageLink(text1)); // true
 * console.log(isImageLink(text2)); // true
 * console.log(isImageLink(text3)); // false
 */
export function isValidUrl(url: string) {
  try {
    return Boolean(new URL(url))
  } catch {
    return false
  }
}
